import React, { Component } from "react";
import { BsFillHouseDoorFill, BsSearch, BsGear } from "react-icons/bs";
import * as k from "./constants";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  gotoTab(tabName) {
    this.props.appProps.handleAppsState("currentScreen", tabName);
  }

  render() {
    return (
      <div class="footer fixed-bottom">
        <div className="container-fluid py-1 bg-dark text-white">
          {this.props.appProps.state.authorized ? (
            <div>
              <div className="row p-2">
                <div className="col text-center pointer">
                  <BsFillHouseDoorFill
                    onClick={() => this.gotoTab(k.HOME)}
                    size={k.TABICONSIZE}
                  />
                </div>
                <div className="col text-center pointer">
                  <BsSearch
                    onClick={() => this.gotoTab(k.SEARCH)}
                    size={k.TABICONSIZE}
                  />
                </div>
                <div className="col text-center pointer">
                  <BsGear
                    onClick={(e) => this.gotoTab(k.SETTINGS)}
                    size={k.TABICONSIZE}
                  />
                  {/* </label> */}
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <div className="inline">
            <small className="pr-4 ">@sMedia</small>
            <small className="pr-4 pointer">Terms of service</small>
            <small className="pr-4 pointer">Privacy policy</small>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
